import { capitalize, splitByUppercase } from '../../../utils/text.js'
import { ReferenceInput } from '../../ReferenceInput/index.js'

// export type SchemaReferences = Prop<{
//     type?: 'references';
//     default?: number[];
//     items: SchemaReference & NeverInItems;
// }>;
// export type SchemaReferencesOneWay = Prop<{
//     type?: 'references';
//     default?: number[];
//     items: SchemaReferenceOneWay & NeverInItems;
// }>;
// export type SchemaReference = Prop<{
//     type?: 'reference';
//     default?: number;
//     ref: string;
//     prop: string;
//     dependent?: boolean;
//     mime?: Mime;
// }> & Record<`$${string}`, SchemaPropOneWay>;

export const ReferenceType = ({
  value,
  onChange,
  schemaProp,
  name,
  variant,
  disabled,
}) => {
  const { title, description, readOnly, prop, items, max } = schemaProp

  // console.log('title', title || name, readOnly || disabled)

  return (
    <ReferenceInput
      variant={variant}
      type={items?.ref || schemaProp?.ref}
      value={variant === 'single' && value ? [{ ...value }] : value}
      limit={max}
      onChange={(v) => {
        if (onChange) {
          onChange(v, name)
        }
      }}
      label={capitalize(splitByUppercase(title ?? name))}
      //   description={description}
      disabled={readOnly || disabled}
    />
  )
}
